var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 3.9987H14.6654V5.33203H13.332V13.9987C13.332 14.3669 13.0336 14.6654 12.6654 14.6654H3.33203C2.96384 14.6654 2.66536 14.3669 2.66536 13.9987V5.33203H1.33203V3.9987H4.66536V1.9987C4.66536 1.63051 4.96384 1.33203 5.33203 1.33203H10.6654C11.0336 1.33203 11.332 1.63051 11.332 1.9987V3.9987ZM11.9987 5.33203H3.9987V13.332H11.9987V5.33203ZM5.9987 7.33203H7.33203V11.332H5.9987V7.33203ZM8.66536 7.33203H9.9987V11.332H8.66536V7.33203ZM5.9987 2.66536V3.9987H9.9987V2.66536H5.9987Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.ae9e412dd7bafafd2ef74d616de9d67b.svg";
export { ForwardRef as ReactComponent };